import axios from 'axios'
import qs from 'qs'
import common from '../utils/common'
import config from '../config'
import router from '../router'
import store from '../store'

axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    if (common.getTypeStr(config.data) !== 'object') {
      config.data = {'': config.data}
    }
    config.data = qs.stringify(config.data)
  }
  return config
})

function apiAxios (method, url, params) {
  return new Promise((resolve, reject) => {
    const token = store.getters.token
    if (params && typeof params !== 'string') {
      params = common.filterNull(params)
    }
    axios({
      baseURL: url.indexOf('/token') < 0 ? config.ApiHost + config.ApiPath : config.ApiHost,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + token
      },
      method: method,
      url: url,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null
    })
    .then(response => {
      const res = response.data
      // if (res.code !== 200) {
      //   //
      //   reject(res)
      // }
      resolve(res)
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        store.dispatch('ClearUserInfo')
        if (router.history.current.name !== 'wxlogin') {
          router.push('/login')
        }
      }
      reject(error)
    })
  })
}

export default {
  get: function (url, params) {
    return apiAxios('GET', url, params)
  },
  post: function (url, params) {
    return apiAxios('POST', url, params)
  },
  put: function (url, params) {
    return apiAxios('PUT', url, params)
  },
  delete: function (url, params) {
    return apiAxios('DELETE', url, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js